import { waitForFlickity } from '@utilities/theme';

if(!customElements.get('instagram-slider')) {
  class InstagramSlider extends HTMLElement {
    constructor() {
      super();
      this.breakpoint = 1280;
      this.handleResize = this.handleResize.bind(this);
      this.waitForFlickityCleanup = null;
    }

    destroySlider() {
      if(!this.slider) return;

      this.slider.destroy();
    }

    initSlider() {
      if (!window.Flickity) return;
      if(this.slider) return this.slider.resize();

      this.slider = new window.Flickity(this, {
        pageDots: false,
        wrapAround: true,
        arrowShape: 'M 10 50 L 50 90 L 55 85 L 20 50 L 55 15 L 50 10 Z',
        cellAlign: 'center',
      });

      this.slider.resize();
    }

    handleResize() {
      if(window.innerWidth > 1280) {
        this.destroySlider();
        return;
      }

      this.initSlider();
    }

    connectedCallback() {
      if (typeof waitForFlickity === 'function') {
        this.waitForFlickityCleanup = waitForFlickity(() => this.handleResize());
      } else if (window.Flickity) {
        this.handleResize();
      }
      window.addEventListener('resize', this.handleResize);

      this.observer = new MutationObserver(() => {
        if(this.slider) this.slider.resize();

        this.handleResize();
      });

      this.observer.observe(this, { childList: true, subtree: true });

      this.interval = window.setInterval(() => {
        if(!this.slider) return;
      
        this.slider.reloadCells();
        this.slider.resize();
        
        const slide = this.querySelector('instagram__item');
        
        if(slide) this.slider.style.height = slide.clientHeight + 'px';

        window.clearInterval(this.interval);
      }, 1000);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      if (typeof this.waitForFlickityCleanup === 'function') {
        this.waitForFlickityCleanup();
        this.waitForFlickityCleanup = null;
      }

      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.interval) {
        window.clearInterval(this.interval);
      }
    }
  }

  customElements.define('instagram-slider', InstagramSlider);
}
